import { HttpErrorResponse } from '@angular/common/http';

export function extractErrorMessage(error: unknown): string {
  if (!(error instanceof HttpErrorResponse)) {
    return error instanceof Error && error.message
      ? error.message
      : 'An unexpected error occurred.';
  }

  const body: unknown = error.error;
  if (typeof body === 'object' && body !== null) {
    const record = body as { message?: unknown; error?: { message?: unknown } };
    if (typeof record.message === 'string' && record.message) return record.message;
    if (typeof record.error?.message === 'string' && record.error.message) {
      return record.error.message;
    }
  }

  if (error.status === 0) return 'Unable to reach the server. Check your connection.';
  return `Error ${error.status}: ${error.statusText || 'An unexpected error occurred'}`;
}
